@if (products$ | async; as products) {
    <div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0 py-15">
        @if (category$ | async; as category) {
            <app-products-showcase [products]="products" [category]="category" />
        }
    </div>
}
